import script from "./base-chat-input.vue?vue&type=script&setup=true&lang=js"
export * from "./base-chat-input.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__